import { useEffect, useState } from "react";

import { Toast } from "@src/types/shared";

import { toastEvents } from "@services/toasts";

export const useToasts = () => {
    const [toasts, setToasts] = useState<Toast[]>([]);

    useEffect(() => {
        const handleAddToast = (event: CustomEvent) => {
            const toast = event.detail as Toast;
            setToasts(prev => [...prev, toast]);
        };

        const handleRemoveToast = (event: CustomEvent) => {
            const { id } = event.detail;
            setToasts(prev => prev.filter(t => t.id !== id));
        };

        toastEvents.addEventListener(
            "toast:add",
            handleAddToast as EventListener,
        );
        toastEvents.addEventListener(
            "toast:remove",
            handleRemoveToast as EventListener,
        );

        return () => {
            toastEvents.removeEventListener(
                "toast:add",
                handleAddToast as EventListener,
            );
            toastEvents.removeEventListener(
                "toast:remove",
                handleRemoveToast as EventListener,
            );
        };
    }, []);

    const removeToast = (id: string) => {
        toastEvents.removeToast(id);
    };

    return { toasts, removeToast };
};
